import * as api from './purchase-list-api'
import { deepCopy, timeFilter } from '@/untils/untils.js'
export default {
    data() {
        return {
            isMobileFlag: JSON.parse(localStorage.getItem('isMobileFlag')),
            // table
            tableData: [{}],
            journalListData: [],                 //采购单日志列表
            pageSize: 10,
            currPage: 1,
            total: 0,
            currPurchaseData: {},               //当前选择的采购表
            currentSortData: '',                //当前的排序规则

            purchaseLogInfo: {                  //日志
                tahRemark: '',
                tahStart: timeFilter({
                    type: 1,
                    time: new Date()
                }),
                tahEnd: timeFilter({
                    type: 1,
                    time: new Date()
                }),
                tpId: '',
                purchaseId: '',
            },

            /* 日志time */
            timeSelect: {
                selectStart: '09:00:00',
                selectEnd: '18:00:00'
            },
            timeSelectEndOption: [],
            timeSelectStartOption: [],
            purchaseLogTitle: '',                //日志弹窗标题

            /* 是否为修改 */
            editFlag: false,
            // dialog
            dialogVisible: false,               //日志信息
            approveDialogVisible: false,         //审批弹窗
            approveDialogVisibleMobile: false,   //审批弹窗手机
            /* 下拉列表 */
            engineerList: [],                   //工程师
            projectList: [],                    //项目
            purchaseCategoryList: [],           //采购单分类
            purchaseNameList: [],
            /* queryInfo 搜索 */
            queryInfo: {
                tpId: '',
                status: '',
                orderParam: []
            },
            /* 审核 */
            approveProjectData: [],
            approveInfo: {
                checkStatus: 1,
                checkRemark: '',
                id: '',
            },
            /* 返回跳转 */
            jumpCurrpage: '',
            jumpPagesize: '',
        }
    },
    filters: {
        tableHandler(val, list, key, value) {
            if (!list.length || !val) return
            return list.filter(t => t[key] === val)[0][value]
        },
    },
    watch: {
        pageSize(val) {
            this.currPage = this.jumpPagesize ? this.jumpPagesize : 1
            this.queryPurchaseList()
            this.jumpPagesize = ''
        },
        queryInfo: {
            deep: true,
            handler(val) {
                if (Object.values(val).some(t => !t)) {
                    this.queryPurchaseList()
                }
            }
        },
    },
    created() {
        /* 是否是跳转过来 */

        let { query: {
            queryInfo,
            page,
            size,
            sortData,
        } } = this.$route
        this.pageSize = size ? size : this.pageSize
        this.currPage = page ? +page : this.currPage
        this.jumpCurrpage = page ? page : this.jumpCurrpage
        this.jumpPagesize = page ? page : this.jumpPagesize

        if (queryInfo) {
            let { tpId, status } = JSON.parse(queryInfo)
            this.queryInfo.tpId = tpId ? tpId : ''
            this.queryInfo.status = status ? status : ''
        }
        let sort = sortData ? JSON.parse(sortData) : ''
        console.log(sort);
        if (sort) {
            this.$nextTick(() => {
                let { prop, order } = sort
                this.$refs.tableRef.sort(prop, order)
                this.tableSortChange(sort)
            })
        }
    },
    mounted() {
        this.queryPurchaseList()
        this.findProjectCategory('purchasetype')
        this.findProjectDownList()
        this.queryPurchaseSelector()
        /* 初始化结束时间下拉框参数 */
        for (let index = 1; index < 25; index++) {
            let item = index > 9 ? index + ':00:00' : '0' + index + ':00:00'
            this.timeSelectStartOption.push(item)
        }
        this.timeSelectEndOption = deepCopy(this.timeSelectStartOption)
    },
    methods: {

        /* api ************************************************************************/

        addActualHour() {               //新增日志

            api.addActualHour(this.purchaseLogInfo).then(data => {
                this.purchaseLogInfo = {                  //日志
                    tahRemark: '',
                    tahStart: timeFilter({
                        type: 1,
                        time: new Date()
                    }),
                    tahEnd: timeFilter({
                        type: 1,
                        time: new Date()
                    }),
                    tpId: '',
                    purchaseId: '',
                }
                this.timeSelect = {
                    selectStart: '09:00:00',
                    selectEnd: '18:00:00'
                }
                if (data) {
                    let d = data.data.resultObject
                    this.$message.success('操作成功')
                    let { id: purchaseId, tpId } = this.currPurchaseData
                    this.queryPurchaseLog({ purchaseId, tpId })
                }
            })
        },

        queryPurchaseList(params) {             //查询采购单列表
            let {
                currPage,
                pageSize
            } = this
            api.queryPurchaseList(
                {
                    ...this.queryInfo,
                    ...params,
                    currPage,
                    pageSize
                }
            ).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.tableData = d.dataList
                    this.total = d.totalCount
                    if (this.jumpCurrpage) {
                        this.currPage = this.jumpCurrpage
                        this.jumpCurrpage = ''
                    }
                }
            })
        },

        queryPurchaseLog(params) {            //查新采购单日志
            api.queryPurchaseLog(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.journalListData = d
                    this.dialogVisible = true
                }
            })
        },

        delPurchase(params) {                 //删除采购单
            api.delPurchase(params).then(data => {
                if (data) {
                    let d = data.data.resultMessage
                    this.queryPurchaseList()
                    this.$message.success(d)
                }
            })
        },


        findProjectCategory(type) {             // 项目分类
            api.findProjectCategory(type).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.purchaseCategoryList = d
                }
            })
        },

        findProjectDownList() {                //查询项目下拉列表
            api.findProjectDownList({}).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.projectList = d

                }
            })
        },

        queryPurchaseSelector() {                //查询项目下拉列表
            api.queryPurchaseSelector({}).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.purchaseNameList = d

                }
            })
        },

        checkPurchase() {                             //项目采购单审核
            api.checkPurchase(this.approveInfo).then(data => {
                if (data) {
                    let d = data.data.resultMessage
                    this.$message.success(d)
                    this.approveDialogVisible = false
                    this.approveDialogVisibleMobile = false
                    this.queryPurchaseList()
                }
            })
        },






        /* handle */

        openJournalList(row) {
            let { id: purchaseId, tpId, purchaseRemark, tpName } = row
            this.purchaseLogTitle = tpName + '-' + purchaseRemark
            this.currPurchaseData = deepCopy(row)
            this.queryPurchaseLog({ purchaseId, tpId })
        },

        openModify(row) {                             //跳转到修改页面
            let { id } = row
            this.$router.push({
                path: '/add-purchase',
                query: {
                    id,
                    queryInfo: JSON.stringify(this.queryInfo),
                    page: this.currPage,
                    size: this.pageSize,
                    sortData: JSON.stringify(this.currentSortData)
                }
            })
        },

        deleteRowData(row) {
            this.delPurchase(row)
        },

        addPurchaseLog() {
            let { id: purchaseId, tpId } = this.currPurchaseData
            let { tahStart, tahEnd, tahRemark } = this.purchaseLogInfo
            if (!tahRemark.trim()) return this.$message.warning('日志不能为空')
            this.purchaseLogInfo.purchaseId = purchaseId

            this.purchaseLogInfo.tpId = tpId

            let time = timeFilter(new Date())

            this.purchaseLogInfo.tahStart = tahStart + '' + timeFilter(new Date()).slice(10)

            this.purchaseLogInfo.tahEnd = tahStart + '' + timeFilter(new Date()).slice(10)

            this.purchaseLogInfo.source = 1

            this.addActualHour(this.purchaseLogInfo)

        },
        /*审核 */
        showApproveProjectDialog(row) {
            let { checkStatus, id, checkRemark } = row
            this.approveProjectData = row
            console.log(this.approveProjectData);
            if (checkStatus == '1' || checkStatus == '2') { this.approveInfo.checkStatus = checkStatus } else {
                this.approveInfo.checkStatus = 1
            }
            this.approveInfo.checkRemark = checkRemark
            this.approveInfo.id = id
            this.isMobileFlag ? this.approveDialogVisibleMobile = true : this.approveDialogVisible = true
        },

        approveProject() {
            this.checkPurchase()
        },

        closeApproveDialog() {
            this.approveInfo = {                //审批信息
                checkStatus: 1,
                checkRemark: '',
                id: '',
            }
        },


        handleCurPageChange(val) {
            this.currPage = val
            this.queryPurchaseList()
        },
        // 索引
        indexMethod(index) {
            return (this.currPage - 1) * this.pageSize + index + 1
        },

        /* 关键词查询 */
        queryInfoByKeyword() {
            this.currPage = 1
            this.queryPurchaseList()
        },
        /* 日志时间选择处理 */
        /* 时间选择器 */
        startTimeChange(val) {
            this.purchaseLogInfo.tahEnd = val
        },
        endTimeChange(val) {
            this.purchaseLogInfo.tahStart = val
        },
        selectStartChange(val) {
            let idx = this.timeSelectStartOption.findIndex(t => t === val)
            this.timeSelectEndOption = this.timeSelectStartOption.slice(idx)
            this.timeSelect.selectEnd = this.timeSelectEndOption[0]
        },
        /* 排序 */
        tableSortChange({ prop, order }) {
            this.queryInfo.orderParam = []
            this.currentSortData = { prop, order }
            let key = ''
            switch (prop) {
                case 'receiveTime':
                    key = 'receive_time'
                    break;
                case 'createDate':
                    key = 'mh_project_purchase.create_date'
                    break;
            }
            let o = order == 'ascending' ? `${key} asc` : `${key} desc`
            if (order !== null) {
                this.queryInfo.orderParam.push(o)
            }

            this.queryPurchaseList()
        },

        /* 手机端无法搜索 */
        cancalReadOnly(onOff) {
            this.$nextTick(() => {
                if (!onOff) {
                    const selects = Array.from(document.querySelectorAll('.mySelect'))
                    console.log(selects);
                    selects?.map(t => {
                        let input = t.querySelector('.el-input__inner')
                        input.removeAttribute('readonly');
                    })
                }
            });
        }
    },
}